import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { LaunchCommandCenter } from './launch.types';

export const launchApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<LaunchCommandCenter>('/v1/launch/command-center', options),
  runSmoke: (_input: void, options?: RequestOptions) => apiClient.post<LaunchCommandCenter['runs'][number]>('/v1/launch/smoke', {}, options),
};
